export default __webpack_public_path__ + "static/media/slozeno.f6a30618.JPG";